import React from 'react';
import { NavLink } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import './pricingoptionbody.styl'

function PricingOptionBodyPrice(props) {
  return (
    <div className="pricing-option-body__price">
      { props.pre &&
        <span className="pricing-option-body__price__pre">{ props.pre }</span>
      }
      <span className={'pricing-option-body__price__amount ' + props.currency }>{ props.amount }</span>
      <span className="pricing-option-body__price__after">{ props.after }</span>
    </div>
  );
}

class PricingOptionBody extends React.Component {
  render() {
    return (
      <div className="pricing-option-body">
        <div>
          { (this.props.price && (typeof this.props.price !== 'string') &&
              <PricingOptionBodyPrice
                pre={ this.props.price.pre }
                amount={ this.props.price.amount }
                currency={ this.props.price.currency }
                after={ this.props.price.after }
              />)
          }
          { this.props.price && (typeof this.props.price === 'string') &&
              <span className="pricing-option-body__price-placeholder" dangerouslySetInnerHTML={{ __html: this.props.price }} />
          }
          <ul className="pricing-option-body__features">
            {this.props.features.map(feature => {
              return (
                <li key={feature.text}>
                  { feature.text }
                  { feature.meta &&
                    <span>{ feature.meta }</span>
                  }
                </li>
              )
            })}
          </ul>
        </div>
        <NavLink className="pricing-option-body__cta" to={ this.props.cta.linkAddress }>{ this.props.cta.text }</NavLink>
      </div>
    );
  }
}

export default PricingOptionBody;



// WEBPACK FOOTER //
// ./src/components/pricingoptions/pricingoption/PricingOptionBody.js